import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import CompliantList from "./CompliantList";
import CreateCompliant from "./CreateCompliant";
import CreateCompliantUser from "./CreateCompliantUser";
import EditCompliant from "./EditCompliant";
import ViewCompliantUser from "./ViewCompliantUser";

export default function WaterTank() {
  return (
    <Switch>
      <Redirect exact={true} from="/aprt-customer" to="/aprt-customer/customer-list" />

      {/* Layout */}
      <Route exact={true} path="/register-compliant/compliant-list" component={CompliantList} />
      <Route exact={true} path="/register-compliant/create-compliant" component={CreateCompliant} />
      <Route exact={true} path="/register-compliant/create-compliant-user" component={CreateCompliantUser} />
      <Route exact={true} path="/register-compliant/edit-compliant" component={EditCompliant} />
      <Route exact={true} path="/register-compliant/view-compliant-user" component={ViewCompliantUser} />
    </Switch>
  );
}
